'use client';

import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@common/components';
import { FOCUS_RING } from '@common/components/interaction';
import { cn } from '@core/utils';
import { useEffect, useRef } from 'react';
import { TrendKeywordPager } from './TrendKeywordPager';
import { TrendKeywordToggle } from './TrendKeywordToggle';
import { TrendKeywordTrack } from './TrendKeywordTrack';
import { useTrendKeyword } from './useTrendKeyword';
export const TrendKeywordInline = () => {
  const $ = _c(11);
  const {
    keywords,
    step,
    isOpen,
    isPending,
    currentKeyword,
    search,
    toggle,
    close
  } = useTrendKeyword();
  const containerRef = useRef(null);
  let t0;
  let t1;
  if ($[0] !== close || $[1] !== isOpen) {
    t0 = () => {
      if (!isOpen) {
        return;
      }
      const handlePointerDown = event => {
        if (!containerRef.current?.contains(event.target as Node)) {
          close();
        }
      };
      const handleKeyDown = event_0 => {
        if (event_0.key === "Escape") {
          close();
        }
      };
      document.addEventListener("pointerdown", handlePointerDown);
      document.addEventListener("keydown", handleKeyDown);
      return () => {
        document.removeEventListener("pointerdown", handlePointerDown);
        document.removeEventListener("keydown", handleKeyDown);
      };
    };
    t1 = [isOpen, close];
    $[0] = close;
    $[1] = isOpen;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  if (!isPending && !currentKeyword) {
    return null;
  }
  let t2;
  if ($[4] !== currentKeyword || $[5] !== isOpen || $[6] !== keywords || $[7] !== search || $[8] !== step || $[9] !== toggle) {
    t2 = <div ref={containerRef} className="relative h-44 w-[300px] shrink-0">{isOpen ? <div className="absolute inset-x-0 top-0 z-30 flex flex-col rounded-medium border border-Gray-200 bg-Gray-white p-12 shadow-home"><TrendKeywordPager keywords={keywords} onSelect={search} /></div> : <div className="flex h-44 items-center gap-4 rounded-medium border border-Gray-200 bg-Gray-white pl-16 pr-12">{currentKeyword ? <button className={cn("flex h-36 min-w-0 flex-1 animate-fade items-center rounded-xsmall motion-reduce:animate-none", "transition-colors duration-150 active:bg-Gray-100 motion-reduce:transition-none", FOCUS_RING)} aria-label={`${currentKeyword.ranking}위 ${currentKeyword.keyword} 검색`} onClick={() => search(currentKeyword.keyword)}><TrendKeywordTrack keywords={keywords} step={step} size="desktop" /></button> : <span className="flex h-36 min-w-0 flex-1 items-center"><Skeleton typo="caption1" className="w-120 rounded-xsmall" /></span>}{currentKeyword && <TrendKeywordToggle isOpen={isOpen} onToggle={toggle} />}</div>}</div>;
    $[4] = currentKeyword;
    $[5] = isOpen;
    $[6] = keywords;
    $[7] = search;
    $[8] = step;
    $[9] = toggle;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
};